import React from 'react';
import _get from 'lodash/get';
import { makeStyles } from '@material-ui/core';
import Badge from 'components/Badge';
import LabelValue from 'components/LabelValue';
import { SeriesActionButtons } from './SeriesActionButtons';

const useStyles = makeStyles(() => ({
  detailsContainer: {
    display: 'flex',
    alignItems: 'center',
    margin: props => (props.isMobile ? '10px 0px' : '16px 0px'),
  },
  badgeRoot: {
    paddingRight: 0,
    flexShrink: 0,
  },
  badgeContainer: {
    height: 'auto',
    margin: 0,
    fontSize: props => props.fontSize,
    '& span': {
      color: 'inherit',
      paddingTop: 0,
      marginLeft: 15,
    },
  },
  divider: {
    borderRight: '1px solid #C0BFBF',
    margin: '0 15px',
    height: 22,
  },
  labelValueContainer: {
    display: 'inline-flex',
    alignItems: 'center',
    overflow: 'hidden',
  },
  label: {
    '& span, & a': {
      fontSize: props => `${props.fontSize} !important`,
    },
  },
}));

export const SeriesResourceDetails = ({
  fontSize,
  allowSignIn,
  type,
  resource,
  seriesSiteCopy,
  resourcePathname,
  isMobile,
  showShareAction,
  renderHeartButton,
}) => {
  const classes = useStyles({ fontSize, isMobile });

  const person = _get(resource, 'fields.person');
  const byLabel = _get(seriesSiteCopy, 'pageCopy.by');
  const orgsSeparator = person ? ',' : byLabel;

  return (
    <div className={classes.detailsContainer}>
      <Badge customClasses={classes} type={type} />
      <div className={classes.labelValueContainer}>
        {person && (
          <>
            <div className={classes.divider} />
            <LabelValue
              target="_blank"
              label={byLabel}
              value={person}
              className={classes.label}
            />
          </>
        )}
        {_get(resource, 'fields.organization') && (
          <>
            {!person && <div className={classes.divider} />}
            <LabelValue
              target="_blank"
              label={orgsSeparator}
              type="organizations"
              value={resource.fields.organization}
              className={classes.label}
            />
          </>
        )}
        <div className={classes.divider} />
        <SeriesActionButtons
          allowSignIn={allowSignIn}
          type={type}
          item={resource}
          resourcePathname={resourcePathname}
          showShareAction={showShareAction}
          renderHeartButton={renderHeartButton}
        />
      </div>
    </div>
  );
};
